import React from 'react';
import * as ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import ArchivedGame from './components/ArchivedGame/ArchivedGame.tsx';
import ArchivePage from './components/ArchivePage/ArchivePage.tsx';
import DailyGame from './components/DailyGame/DailyGame.tsx';
import HomePage from './components/HomePage/HomePage.tsx';
import PrivacyPolicy from './utils/PrivacyPolicy.js';
import { GameType } from './types/GameType.ts';
import RouteRedirects from './components/RouteRedirects.tsx';
import PageMetadata from './components/PageMetadata/PageMetadata.tsx';
import { NotificationProvider } from './components/GameContainer/NotificationContext.tsx';
import { AuthProvider } from './supabase/AuthContext.tsx';
import AuthModal from './components/Auth/AuthModal.tsx';
import './supabase/syncService.ts'; // Registers sync callback on module load
import PubliftNavigationHandler from './components/PubliftNavigationHandler.tsx';
import { initializeErrorTracking } from './utils/loggingUtils.ts';

// Initialize error tracking before rendering to catch early errors
initializeErrorTracking();

ReactDOM.render(
  <HelmetProvider>
    <Router>
      <App />
    </Router>
  </HelmetProvider>,
  document.getElementById('app-container')
);

function App() {
  return (
    <AuthProvider>
    <NotificationProvider>
      <AuthModal />
      <PubliftNavigationHandler />
      <PageMetadata />
      <RouteRedirects />
      <Routes>
        <Route path="/weaver/archive" element={<ArchivePage gameType={GameType.WEAVER} />} />
        <Route path="/weaver-x/archive" element={<ArchivePage gameType={GameType.WEAVER_X} />} />
        <Route path="/subtext/archive" element={<ArchivePage gameType={GameType.SUBTEXT} />} />
        <Route path="/weaver/game/:gameNumber" element={<ArchivedGame gameType={GameType.WEAVER} />} />
        <Route path="/weaver-x/game/:gameNumber" element={<ArchivedGame gameType={GameType.WEAVER_X} />} />
        <Route path="/subtext/game/:gameNumber" element={<ArchivedGame gameType={GameType.SUBTEXT} />} />
        <Route path="/staging" element={
          <DailyGame 
            gameNumber={null} 
            isArchive={false} 
            gameType={GameType.WEAVER} 
          />
        } />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/weaver-x" element={
          <DailyGame 
            gameNumber={null} 
            isArchive={false} 
            gameType={GameType.WEAVER_X} 
          />
        } />
        <Route path="/weaver-x/" element={
          <DailyGame 
            gameNumber={null} 
            isArchive={false} 
            gameType={GameType.WEAVER_X} 
          />
        } />
        <Route path="/weaver" element={
          <DailyGame 
            gameNumber={null} 
            isArchive={false} 
            gameType={GameType.WEAVER} 
          />
        } />
        <Route path="/weaver/" element={
          <DailyGame 
            gameNumber={null} 
            isArchive={false} 
            gameType={GameType.WEAVER} 
          />
        } />
        <Route path="/" element={<HomePage />} />
        <Route path="/subtext" element={
          <DailyGame 
            gameNumber={null} 
            isArchive={false} 
            gameType={GameType.SUBTEXT} 
          />
        } />
        <Route path="/subtext/" element={
          <DailyGame 
            gameNumber={null} 
            isArchive={false} 
            gameType={GameType.SUBTEXT} 
          />
        } />
      </Routes>
    </NotificationProvider>
    </AuthProvider>
  );
}